import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSetAtom } from "jotai";
import useLaunchCloud from "./useLaunchCloud";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { tenantAtom } from "../../../atoms/GlobalAtoms";
import API from "../../api/API";
import Constants from "../../../utils/Constants";

// Designed for cloud creation inside and outside of supportal
const useCreateCloud = ({ isSupportal = false }: { isSupportal?: boolean }) => {
  const queryClient = useQueryClient();
  const setTenant = useSetAtom(tenantAtom);
  const { launchCloud } = useLaunchCloud();

  const createCloud = useMutation({
    mutationFn: ({
      payload,
    }: {
      payload: any;
      openCloud?: boolean;
      onSuccess?: () => void;
    }) => {
      return API.createCloudTenant(payload);
    },
    onSuccess: (data, { openCloud = true, onSuccess }) => {
      const newCloud = data.data.data.tenant;

      // Update user clouds
      queryClient.setQueryData(["clouds"], (prev: any) => {
        if (!Array.isArray(prev)) return prev;
        return [...prev, newCloud];
      });

      if (isSupportal) {
        queryClient.invalidateQueries({
          queryKey: [Constants.SUP_CLOUD_ID, "records", "Tenants"],
        });
      } else {
        setTenant(newCloud);
      }

      openCloud && launchCloud({ userTenant: newCloud });
      callFunctionIfExists(onSuccess);
    },
  });

  return {
    createCloud: createCloud.mutate,
    creatingCloud: createCloud.isPending || false,
    createCloudError: createCloud.error
      ? getErrorMessage(createCloud.error)
      : null,
  };
};

export default useCreateCloud;
